import { concat, Observable } from 'rxjs';
import { AbstractWebSocketService } from './abstract-web-socket-service';

export class WebSocketUtils {
  public static connect(...services: AbstractWebSocketService[]): Observable<void> {
    return concat(...services.map((s) => s.ensureConnected()));
  }

  public static disconnect(...services: AbstractWebSocketService[]): Observable<void> {
    return concat(...services.map((s) => s.disconnect()));
  }
}
